import React from 'react';
import App from 'next/app';
import HeadAmend from '../components/ui/HeadAmend';
import { ClerkProvider } from '@clerk/nextjs';
// import theme, { fontsToInclude } from '../config/theme';


import '../styles/index.css';

import '../node_modules/react-grid-layout/css/styles.css';
import '../node_modules/react-resizable/css/styles.css';

import 'draft-js/dist/Draft.css';

// const environment = process.env.isDev
//   ? 'development'
//   : process.env.isStaging
//   ? 'staging'
//   : 'production';
// Disable in local development
if (!process.env.isDev && process.env.SENTRY_DSN) {
  // try {
  //   Sentry.init({
  //     dsn: `${process.env.SENTRY_DSN}`,
  //     environment,
  //   });
  // } catch (error) {
  //   console.log(error);
  // }
}

class MyApp extends App {
  static async getInitialProps({ Component, ctx }) {
    const pageProps = Component.getInitialProps ? await Component.getInitialProps(ctx) : {};
    pageProps.err = ctx.err;
    return {
      pageProps,
    };
  }

  componentDidMount() {
    const jssStyles = document.querySelector('#jss-server-side');
    if (jssStyles && jssStyles.parentNode) jssStyles.parentNode.removeChild(jssStyles);
  }

  componentDidCatch(error, _errorInfo) {
    console.log(`ERROR: ${error}`);
  }

  render() {
    const { err, pageProps, Component } = this.props as any;
    // useEffect(() => {
    // logEvent('Data page loaded');
    // Sentry.captureException(new Error("This is my fake error message"));
    // });

    // // Workaround for https://github.com/zeit/next.js/issues/8592
    return (
      <ClerkProvider {...pageProps}>
        <HeadAmend
          defaultTitle="Openroad"
          fontsToInclude={[
            'https://fonts.googleapis.com/css2?family=Source+Sans+Pro:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap',
          ]}
        >
          <Component {...pageProps} err={err} />
        </HeadAmend>
      </ClerkProvider>
    );
  }
}

export default MyApp;
